// extracted by mini-css-extract-plugin
export default {"label":"ta_label__LMWdx","txarea":"ta_txarea__it-OT"};